module.exports = __webpack_public_path__ + "static/media/resi01.e8eda840.jpeg";